import React, { useEffect, useState, memo } from 'react';
import { connect } from 'react-redux';
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import PropTypes from 'prop-types';

import moment from 'utils/moment';
import SectionHeader from '../../components/sectionHeader';
import Loading from '../../components/loading';
import { renderInfoForType } from '../../utils/helpers';
import { fetchSmsSafetyPromtions, getEventsMeetings, fetchDefaultTiles } from './redux/actions';
import CustomTiles from './components/DragableCustomTiles/CustomTiles';

import styles from './safetyPromotion.module.scss';
import icon from '../../icons/AirportOperations.png';
import UserImg from '../../icons/default_avatar.jpg';

function SmsSafetyPromotions({ customTiles, fetchSmsSafety, getMeetings, meetingsData, defaultTiles, getDefaultTiles, action }) {
  const [selectedDate, setSelectedDate] = useState(new Date());


  useEffect(() => {
    fetchSmsSafety();
    getDefaultTiles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    getMeetings(moment(date).format('YYYY-MM-DD'));
  };

  return (
    <>
      <Loading loadingStatus={action.loading} />
      <SectionHeader
        icon={icon}
        translationID="Safety Promotions"
        defaultTitle="Safety Promotions"
      />
      <div style={{ display: 'flex' }}>
        <div style={{ width: '350px' }}>
          {defaultTiles?.length>0 && defaultTiles.find(item => item?.tile_name ==='Calendar')?.visibility && (
            <div style={{ width: '100%' }} className={styles.calendarStyles}>
              <Calendar
                dateFormat="yyyy-MM-DD"
                date={selectedDate}
                onChange={handleDateChange}
              />
            </div>
          )}
          {meetingsData?.length>0 && meetingsData.map(item => (
            (item?.type === undefined
                && (
                <div className={styles.meetingstyles}>
                  <div className={styles.meetingList}>
                      <>
                        <div className={styles.meetingInfo}>
                          <div className={styles.timeUser}>
                            <div className={styles.meetingUser}>
                              <p>{item?.name}</p>
                              <div className={styles.userImg}>
                                <h6>Invitees:</h6>
                                {item?.attendees?.length > 0 && item.attendees.map(user_img => (
                                  <ul>
                                    <li>
                                      <img src={user_img.image ? user_img.image : UserImg} width="26px" alt="" />
                                    </li>
                                  </ul>
                                ))}
                              </div>
                            </div>
                            <div className={styles.meetingTime}>
                              <p>
                                <span>Start Time: </span>
                                {renderInfoForType({ type: 'time' }, item?.start_time, null, null)}
                                <br />
                                <span>End Time: </span>
                                {renderInfoForType({ type: 'time' }, item?.end_time, null, null)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                  </div>
                </div>
                )
            )
          ))}
          {meetingsData?.length>0 && meetingsData.map(item => (
            (item?.type === 'event'
                && (
                <div className={styles.eventstyles}>
                  <div className={styles.meetingList}>
                    <div className={styles.meetingInfo}>
                      <div className={styles.timeUser}>
                        <div className={styles.eventUser}>
                          <p>{item?.event_name}</p>
                          <div className={styles.userImg}>
                            <a href={item.hyperlink} target="_blank" rel="noopener noreferrer">
                              {item?.hyperlink}
                              {' '}
                            </a>
                          </div>
                        </div>
                        <div className={styles.eventMeetingTime}>
                          <p>
                            <span>Event Time: </span>
                            {renderInfoForType({ type: 'time' }, item?.time, null, null)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                )
            )
          ))}
        </div>
        <div className={`container ${styles.container}`}>
          <div className={`${styles.onhide}`}>
            {customTiles?.length>0
                && (
                <CustomTiles
                  data={customTiles}
                  layout={customTiles.map((val) => {
                    if (val?.tile_type !== 2) {
                      return { ...val?.meta_data?.drag_values, isDraggable: false, isResizable: false };
                    }
                    return '';
                  })}
                />
                  )
          }
          </div>
        </div>
      </div>
    </>
  );
}

SmsSafetyPromotions.propTypes = {
  fetchSmsSafety: PropTypes.func.isRequired,
  getMeetings: PropTypes.func.isRequired,
  getDefaultTiles: PropTypes.func.isRequired,
  action: PropTypes.shape({}).isRequired,
  defaultTiles: PropTypes.shape([]).isRequired,
  meetingsData: PropTypes.shape([]).isRequired,
  customTiles: PropTypes.shape([]).isRequired
};

const mapStateToProps = state => ({
  customTiles: state.smsSafetyPromotion.customTiles,
  meetingsData: state.smsSafetyPromotion.smsSafetyPromMeetings,
  defaultTiles: state.smsSafetyPromotion.defaultTiles,
  action: state.smsSafetyPromotion.action
});

const mapDispatchToProps = dispatch => ({
  fetchSmsSafety: () => {
    dispatch(fetchSmsSafetyPromtions());
  },
  getMeetings: (date) => {
    dispatch(getEventsMeetings(date));
  },
  getDefaultTiles: () => {
    dispatch(fetchDefaultTiles());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(SmsSafetyPromotions));
